/**
 * 모바일 메뉴얼 트리 메뉴 전용 유틸.
 * NewManualTreeMenuSlot.vue 를 import 하지 않고 동일 계열 로직만 여기서 재사용합니다.
 */

/**
 * 같은 parentId 형제 중 draft(-1) 제외
 * @param {Array} menus 플랫 메뉴 배열
 * @param {{ parentId: *, manualId: number }} manual 기준 행
 */
export function filterSiblingMenusExcludingDraft(menus, manual) {
    return (menus || []).filter(
        (menu) => menu.parentId === manual.parentId && menu.manualId !== -1
    );
}

/**
 * 같은 부모 아래 sequence 순으로 정렬된 형제에서, 위/아래 이웃 행 반환
 * @param {'up'|'down'} arrow
 * @returns {*|undefined} 이웃 행 또는 undefined
 */
export function findReorderNeighbor(manual, arrow, menus) {
    const sameParentMenu = filterSiblingMenusExcludingDraft(menus, manual).sort(
        (a, b) => a.sequence - b.sequence
    );
    const findClickMenuIndex = sameParentMenu.findIndex(
        (menu) => menu.manualId === manual.manualId
    );
    let frontMenu;
    let backMenu;
    if (findClickMenuIndex === 0 && sameParentMenu.length === 1) {
        frontMenu = undefined;
        backMenu = undefined;
    } else if (findClickMenuIndex === 0) {
        frontMenu = undefined;
        backMenu = sameParentMenu[findClickMenuIndex + 1];
    } else if (findClickMenuIndex === sameParentMenu.length - 1) {
        frontMenu = sameParentMenu[findClickMenuIndex - 1];
        backMenu = undefined;
    } else {
        frontMenu = sameParentMenu[findClickMenuIndex - 1];
        backMenu = sameParentMenu[findClickMenuIndex + 1];
    }
    return arrow === "up" ? frontMenu : backMenu;
}
